import styled from 'styled-components';

export const Info = styled.div`
  /* color: #000; */
  font-size: 16px;
  text-align: center;
  line-height: 1.3;
  margin: 30px 0 0;
  p {
    margin: 0 0 3px;
  }
`;
